<!-- @format -->
<script lang="ts">
  import FilterByDay from "./FilterByDay.svelte";
  import FilterBySearchValue from "./FilterBySearchValue.svelte";
  import FilterByStore from "./FilterByStore.svelte";
  import FilterByCategory from "./FilterByCategory.svelte";
  import type { StoresKey } from "~/stores";
  export let request_store_key: StoresKey;
  export let offers: OrangeAds[];
</script>

<FilterByCategory {request_store_key} />

<FilterByDay {request_store_key} />

<FilterByStore {offers} {request_store_key} />

<FilterBySearchValue {request_store_key} />
